@import (reference) '../../../../../../constants/spacing.module.less';

@widthOfTwoDigitNumber: 32px;
@low-inventory-font-color: var(--inline-message--expired--text-color);
@is-available-font-color: var(--onboarding-page--marketplace--connected-pill-text-color);
@is-allocated-font-color: var(--order-details-canvas--header-buttons--active--text-color);

.stock-level-wrapper {
  display: flex;
  flex-direction: column;
  gap: @space-4;
}

.stock-level-container {
  display: flex;
  justify-content: flex-end;
  width: 82px;
  margin: auto;
}

.stock-level-label {
  display: inline-flex;
  color: var(--default--text-color--17);
  gap: @space-8;
  text-align: right;
  white-space: nowrap;
}

.stock-level {
  color: var(--default--text-color--15);
  text-align: center;
  min-width: @widthOfTwoDigitNumber;
  margin-left: @space-4;
}

.icon-wrapper {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.icon {
  height: 12px;
  width: 12px;
}

.low-stock-level {
  color: @low-inventory-font-color;
  font-weight: 500;
}

.is-available {
  color: @is-available-font-color;
  font-weight: 500;
}

.is-allocated {
  color: @is-allocated-font-color;
  font-weight: 500;
}

.is-allocated-icon,
.untracked-icon {
  color: var(--default--icon--fill-color--12);
}

.untracked-stock-levels {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: @space-8;

  white-space: nowrap;
}
